var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgElectric = function SvgElectric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Electric_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Electric_svg__st0{fill:#262a30}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Electric_svg__Group-2",
    transform: "translate(35 33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Electric_svg__P",
    className: "Electric_svg__st0",
    d: "M3.4 6h1C5.5 6 6 5.5 6 4.5S5.5 3 4.4 3h-1v3zm.1 6.4H.4V.4h4.9c1.3 0 2.3.4 3 1.1.7.7 1.1 1.7 1.1 3s-.4 2.3-1.1 3c-.7.7-1.7 1.1-3 1.1H3.5v3.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Electric_svg__Shape_1_",
    className: "Electric_svg__st0",
    d: "M53 34.5L40.6 22c-.6-.6-1.7-.6-2.3 0L22.2 38.1c-.6.6-.6 1.7 0 2.3l12.4 12.4c1.2 1.2 2.7 1.7 4.1 1.6 1 0 1.9-.4 2.8-.9l2.3 2.3c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l6.4-6.4c.8-.8 1.2-1.8 1.2-2.9 0-1-.4-2.1-1.2-2.9l-2.3-2.3c.5-.9.9-1.8.9-2.8.1-1.4-.4-2.8-1.6-4zm-13.6-9l11.3 11.3c.5.5.7 1.1.7 1.6 0 .7-.4 1.4-1 2-.6.6-.6 1.7 0 2.3l3.4 3.4c.2.2.2.4.2.6 0 .2-.1.4-.2.6l-6.4 6.4c-.2.2-.4.2-.6.2s-.4-.1-.6-.2l-3.4-3.4c-.6-.6-1.7-.6-2.3 0-.6.6-1.3 1-2 1-.5 0-1.1-.2-1.6-.7L25.7 39.3l13.7-13.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Electric_svg__st0",
    d: "M24.7 32.9l-6.8-6.8c-.7-.7-1.7-.8-2.3-.2-.6.6-.5 1.6.2 2.3l6.8 6.8 2.1-2.1zM32.5 25l2.1-2.1-6.8-6.8c-.7-.7-1.7-.8-2.3-.2-.6.6-.5 1.6.2 2.3l6.8 6.8z"
  })));
};
export default SvgElectric;